$(function () {
  $("#c-toggle").click(function () {
    $(this).toggleClass("active");
    $(".p-navi-list__wrap").toggleClass("active");
  });
  $(".faq__list dt").click(function () {
    $(this).toggleClass("open");
    $(this).next("dd").slideToggle(500);
  });

  $(window).scroll(function () {
    if($('#topmain').length){
      let scrollTop = $(window).scrollTop();
      let areaTop = $("#topmain").offset().top;

      if (scrollTop > areaTop) {
        $(".p-navi__wrap").addClass("bk");
        $(".c-toggle__wrap").addClass("bk");
      } else {
        $(".p-navi__wrap").removeClass("bk");
        $(".c-toggle__wrap").removeClass("bk");
      }
    }
  });

  let windowWidth = $(window).width();
  let windowSm = 767;

  if (windowWidth <= windowSm) {
    //横幅767px以下
  } else {
    // 横幅768以上
    $(".p-navi__wrap").hover(
      function () {
        $(".p-navi__wrap").addClass("hv");
      },
      function () {
        $(".p-navi__wrap").removeClass("hv");
      }
    );
  }
});
